import { render, staticRenderFns } from "./StallionExpeditions.vue?vue&type=template&id=10c21270&"
import script from "./StallionExpeditions.vue?vue&type=script&lang=js&"
export * from "./StallionExpeditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports